<div class="container" fxLayout="row" fxFlex="100">
    <div class="breadcrumb" fxFlex="10" fxLayoutAlign="start">
      <p>
        <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
        <span *ngIf="selectedServiceType">{{ selectedServiceType }}</span>
      </p>
    </div>
    <div fxFlex="20" class="service-div" fxLayoutAlign="end">
      <mat-form-field [formGroup]="switchServiceForm" appearance="outline" class="mat-form-field">              
        <mat-select formControlName="switchServiceType" (selectionChange)="switchService()" placeholder="{{ selectedServiceType }}">
            <ng-container *ngIf="selectedServiceType === 'User'; else devicesOption">
            <mat-option value="Devices">Devices</mat-option>
          </ng-container>
          <ng-template #devicesOption>
             <mat-option value="User">User</mat-option>
          </ng-template>
        </mat-select>
      </mat-form-field>
    </div>
  <div fxFlex="60" fxLayoutAling="start">
      <div *ngIf="selectedServiceType === 'User'">
      <app-user-search></app-user-search> 
    </div>
    
    <div *ngIf="selectedServiceType === 'Devices'">
      <app-device-list></app-device-list> 
    </div>
  </div>
</div>